module.exports = __webpack_public_path__ + "static/media/ChantingForFreedomFromFearAndBandage.6f2cdf76.png";